const dataConfig = {
    isChecking: false,
    DEFAULT_GTAG_ID: "UA-149821899-10",
    CASH_PARTNERS:{
        EZ:'Easebuzz',
        YU:'Payu',
        EP:'Ezpay'
    },
    device: {
        lobbyVersion: "1.0.0",
        deviceModel: "", //设备制造商CPU名称，CPU核心数，CPU频率...
        deviceHeight: "", // 屏幕高度
        deviceWidth: "", // 屏幕宽度
        osName: "", // 操作系统
        osVersion: "", // 操作系统版本
        macAddr: "", // mac地址
        udid: "", // 设备udid号
        isp: "", // 运营商
        network: "", // 网络类型4g 3G 2.5G
        appVersion: "", // 运营渠道
        imei: "",
        location: "",
        open_info: "", //
        app_base_ver: "",
        regid: "",
        isEmulator: ""
    },
    withdraw: {
        min: 100, //单次提现的最小值
        max: 40000, //单次提现的最大值
        list: [
            { num: 100 },
            { num: 200 },
            { num: 500 },
            { num: 1000 },
            { num: 2000 },
            { num: 5000 }
        ],
    },
    deposit: {
        list: [
            { num: 100, state: 0 },
            { num: 500, state: 0 },
            { num: 1000, state: 0 },
            { num: 5000, state: 0 },
            { num: 10000, state: 0 },
            { num: 20000, state: 0 }
        ],
        min: 100,
        max: 50000
    },

    filterdata: {
        timedata: {
            list: [{
                name: "1_Day",
                flag: true,
                value: 1
            },
            {
                name: "7_Days",
                flag: false,
                value: 7
            },
            {
                name: "30_Days",
                flag: false,
                value: 30
            }
            ],
            isshow: false,
            name: "Time"
        },
        gamedata: {
            list: [{
                name: "Rummy",
                flag: false,
                value: "4001"
            },
            {
                name: "Teen Patti",
                flag: false,
                value: "4002"
            },
            {
                name: "All",
                flag: true,
                value: 0
            },

            ],
            isshow: false,
            name: "Games"
        },
        statusdata: {
            list: [{
                name: "All",
                flag: true,
                value: 0
            },
            {
                name: "Succeed",
                flag: false,
                value: 1
            },
            {
                name: "Pending",
                flag: false,
                value: 2
            },
            {
                name: "Failed",
                flag: false,
                value: 3
            }
            ],
            isshow: false,
            name: "Status"
        },

        resultdata: {
            list: [{
                name: "All",
                flag: true,
                value: 0
            },
            {
                name: "Win",
                flag: false,
                value: 1
            },
            {
                name: "Failed",
                flag: false,
                value: 2
            }
            ],
            isshow: false,
            name: "Result"
        },
        waydata: {
            list: [{
                name: "All",
                flag: true,
                value: 0
            },
            {
                name: "Stake",
                flag: false,
                value: 1
            },
            {
                name: "Promotions",
                flag: false,
                value: 2
            },
            {
                name: "Gifts",
                flag: false,
                value: 3
            }
            ],
            isshow: false,
            name: "Way"
        },
        typedata: {
            list: [{
                name: "All",
                flag: true,
                value: 0
            },
            {
                name: "Income",
                flag: false,
                value: 1
            },
            {
                name: "Cost",
                flag: false,
                value: 2
            }
            ],
            isshow: false,
            name: "Type"
        },
    },

    fullGameChannels: [ //显示所有游戏的渠道
        "ICWVVFULL",
        "IRAVVXM",
        "IRAVVSP01",
        "IRAVVSP02",
        "IRAVVSP03",
        "IRAVVSP04",
        "IRAVVSP05",
    ],
    googleCheckChannels: [ //google 审核渠道 ，与上面互斥的
        "ICLVVGB",
        "ICLVVGC",
    ],    
    rummyConfig: {
        keyToType: {
            "103105": 1,
            "103106": 1,
            "103107": 1,
            "103108": 1,
            "100801": 1,
            "100802": 1,
            "100803": 1,
            "100804": 1,
            "103101": 1,
            "103102": 1,
            "103103": 1,
            "103104": 1,
            "203101": 2,
            "203102": 2,
            "203103": 2,
            "203104": 2,
            "203105": 2,
            "203106": 2,
            "203107": 2,
            "203109": 2,
            "203110": 2,
            "203111": 2,
            "203112": 2,
            "203113": 2,
            "203114": 2,
            "203115": 2,
            "203116": 2
        },
        common: {
            "2Player": {
                popType: 1,
                gameId: "31",
                localGameId: 4001,
                demoGameId:14301,
                roomId: "1",
                img: "/static/images/game/2Player.jpg",
                rules: [
                    { key: "103105", points: 0.1, join: 8, img: "/static/images/rules/base.jpg" },
                    { key: "103106", points: 1, join: 80, img: "/static/images/rules/middle.jpg" },
                    { key: "103107", points: 5, join: 400, img: "/static/images/rules/heigh.jpg" },
                    { key: "103108", points: 10, join: 800, img: "/static/images/rules/super.jpg" },
                    { key: "403102", points: 10, join: 0, img: "/static/images/rules/base.jpg" }
                ]
            },
            "6Player": {
                popType: 1,
                gameId: "31",
                localGameId: 4001,
                demoGameId:14301,
                roomId: "2",
                img: "/static/images/game/6Player.jpg",
                rules: [
                    { key: "103101", points: 0.05, join: 4, img: "/static/images/rules/base.jpg" },
                    { key: "103102", points: 0.5, join: 40, img: "/static/images/rules/middle.jpg" },
                    { key: "103103", points: 1, join: 80, img: "/static/images/rules/heigh.jpg" },
                    { key: "103104", points: 5, join: 400, img: "/static/images/rules/super.jpg" },
                    { key: "403101", points: 10, join: 0, img: "/static/images/rules/base.jpg" }
                ]
            }
        },
        pool: {
            popType: 2,
            gameId: "31",
            localGameId: 4001,
            demoGameId:14301,
            roomId: "4",
            img: "/static/images/game/pool.jpg",
            players: [
                "2Players",
                "6Players",
            ],
            pools: [
                "101",
                "201",
            ],
            rules: [
                { fee: 25, win: 45, img: "/static/images/rules/base.jpg" },
                { fee: 50, win: 90, img: "/static/images/rules/middle.jpg" },
                { fee: 100, win: 180, img: "/static/images/rules/heigh.jpg" },
                { fee: 200, win: 180, img: "/static/images/rules/super.jpg" },
                { fee: 0, win: 0, img: "/static/images/rules/base.jpg" }
            ],
            keys: {
                "i000": "203101",
                "i001": "203102",
                "i002": "203103",
                "i003": "203104",
                "i010": "203105",
                "i011": "203106",
                "i012": "203107",
                "i013": "203108",
                "i100": "203109",
                "i101": "203110",
                "i102": "203111",
                "i103": "203112",
                "i110": "203113",
                "i111": "203114",
                "i112": "203115",
                "i113": "203116",
                "i004": "403103",
                "i014": "403104",
                "i104": "403105",
                "i114": "403106"
            }
        },
        teenptti: {
            popType: 1,
            localGameId: 4002,
            demoGameId:14302,
            gameId: "8",
            roomId: "3",
            img: "/static/images/game/teenptti.jpg",
            rules: [
                { key: "100801", points: 0.1, join: 4, img: "/static/images/rules/base.jpg" },
                { key: "100802", points: 0.5, join: 20, img: "/static/images/rules/middle.jpg" },
                { key: "100803", points: 1, join: 40, img: "/static/images/rules/heigh.jpg" },
                { key: "100805", points: 5, join: 200, img: "/static/images/rules/super.jpg" },
                { key: "400801", points: 1, join: 0, img: "/static/images/rules/base.jpg" }
            ]
        },
        soon: {
            img: "/static/images/game/come_soon.jpg",
        }
    },
    liveChat: {
        embed: "https://embed.tawk.to/5ee4423e4a7c6258179a8019/default",
        outter: "http://live-chat-in.banggames.com/chat/default"
    }

}

export default dataConfig;



// WEBPACK FOOTER //
// ./src/baseConfig/dataConfig/index.js